import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookReportActionPartsReplacementsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          action_parts_modal: false,
          report_action_id: this.props.report_action_id,
          reports: {},
          report_actions: {},
          report_action_parts_replacements: [],
          engines_list: [],
        };
        this.add = this.add.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            report_action_id: newProps.report_action_id,
            loaded: 1,
          });
        }
        
        if(typeof newProps.reports !== 'undefined' && newProps.reports !== null && this.state.loaded === 1) {
          this.setState({
            reports: newProps.reports,
          });
        }

        if(typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null && this.state.loaded === 1) {
          this.setState({
            report_actions: newProps.report_actions,
          });
        }

        if(typeof newProps.report_action_parts_replacements[this.state.report_action_id] !== 'undefined' && newProps.report_action_parts_replacements[this.state.report_action_id] !== null && this.state.loaded === 1) {
          this.setState({
            report_action_parts_replacements: newProps.report_action_parts_replacements[this.state.report_action_id],
          });
        }

      }

      // Fetch salvando a ação
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_report_action_id: this.state.report_action_id,
          is_engine: this.state.is_engine,
          engine_id: this.state.engine_id,
          part_number: this.state.part_number,
          type: this.state.type,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/reporte/acoes/partes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              is_engine: '',
              engine_id: '',
              part_number: '',
              type: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
      <div>
      <RequestApi ref={'request_api'} />
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Is engine?</label>
                <Select
                  className="form-group"
                  name="is_engine"
                  value={this.state.is_engine}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'is_engine')}
                  options={[
                    {value: 0, label: "No"},
                    {value: 1, label: "Yes"},
                  ]}
                  required
                />
              </div>
            </div>
            {this.state.is_engine === 1 ?
              <div className="col-md-4">
                <div className="form-group">
                  <label>Part Number</label>
                  <br/>
                  <Select
                    className="form-group"
                    name="engine_id"
                    value={this.state.engine_id}
                    searchable={true}
                    placeholder={'Selecionar'}
                    onChange={this.handleSelectChange.bind(this, 'engine_id')}
                    options={this.props.engines_list}
                    required
                  />
                </div>
              </div>
            :
              <div className="col-md-4">
                <div className="form-group">
                  <label>Part Number</label>
                  <br/>
                  <input type="text" className="form-control" value={this.state.part_number} name="part_number" onChange={this.handleChange.bind(this, 'part_number')} placeholder="Part Number" required />
                </div>
              </div>
            }
            <div className="col-md-4">
              <div className="form-group">
                <label>On/Off</label>
                <Select
                  className="form-group"
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={'Selecionar'}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={[
                    {value: "installed", label: "Installed"},
                    {value: "removed", label: "Removed"},
                  ]}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Part's Replacement</caption>
            <thead>
              <tr>
                <th className="text-center vcenter">Is engine?</th>
                <th className="text-center vcenter">Part Number</th>
                <th className="text-center vcenter">On/Off</th>
              </tr>
            </thead>
            <tbody id="parts_replacements">
            {self.state.report_action_parts_replacements.map(function(k) {
              var parts_replacements = k;
              return(
                <tr className="text-center" key={parts_replacements.id}>
                  <td>{parts_replacements.is_engine_str}</td>
                  <td>{parts_replacements.part_number}</td>
                  <td>{parts_replacements.type_str}</td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftLogbookReportActionPartsReplacementsTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookReportActionPartsReplacementsTab.js